// The private menu follows the authenticated server response, never localStorage flags.
export function ownerAiAccessKey(user) {
  if (!user?.id || user.role !== "admin") return null;
  return `${user.id}:${user.role}:${String(user.email || "").toLowerCase()}`;
}

export function canViewOwnerAi(user, access) {
  const key = ownerAiAccessKey(user);
  return Boolean(key && access?.userKey === key && access.allowed === true);
}
